import type { CustomRoute } from '@bo-types/Router';
import { hasValidRoutePermission } from '@bo-utils/routes';
import { selectUserRoles } from '@bo-services/authenticationSlice';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export const useAuthorizePermissions = () => {
  const userRoles = useSelector(selectUserRoles);

  const hasValidPermission = useMemo(() => {
    return ({ route }: { route: CustomRoute | undefined }) =>
      hasValidRoutePermission({ route, userRoles });
  }, [userRoles]);

  return {
    hasValidPermission
  };
};
